export default {
  articles           : [],
  articlesPage       : 1,
  articlesPageLast   : 1,
  articlesLoading    : false,
  articlesSearch     : '',
  articlesTop        : [],
  articlesTopLoading : false,
  categories         : [],
  categoriesCurrent  : null,
  categoriesLoading  : false,
  specialistArticles: []
}
